import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";

import Loader from "../../components/shared/Loader";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import { handleImage } from "./../../helpers/functions";
import TeamModal from "./TeamModal";

const TeamMembersIndex = () => {
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();

	const [image, setImage] = useState("");
	const [teamData, setTeamData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [modalType, setModaleType] = useState("add");
	const [showModal, setShowModal] = useState(false);
	const [selectedTeamMember, setSelectedTeamMember] = useState({});

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		axios
			.get(`${process.env.REACT_APP_API_URL}pages/team-1/sections`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (res) {
				setTeamData(res?.data?.data?.sections);
				setLoading(false);
			})
			.catch(function (err) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const columns = [
		{
			name: "الصورة",
			selector: "icon",
			sortable: true,
			cell: row => {
				return (
					<div
						className="img-rad"
						style={{
							width: "70px",
							height: "70px",
							borderRaduis: "100%",
							overflow: "hidden",
						}}
					>
						<img
							src={handleImage(row?.image)}
							alt={row?.name?.ar}
							style={{
								width: "100%",
								height: "100%",
								objectFit: "cover",
							}}
						/>
					</div>
				);
			},
		},

		{
			name: "العنوان",
			selector: "name.ar",
			sortable: true,
		},

		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-success"
							onClick={() => handleShowModal("edit", row?.slug)}
						>
							<i className="fas fa-edit"></i>
						</button>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleConfrimDelete(row?.slug)}
						>
							<i className="fas fa-trash"></i>
						</button>
					</li>
				</ul>
			),
		},
	];

	const handleConfrimDelete = teamMemberSlug => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteMember(teamMemberSlug),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteMember = teamMemberSlug => {
		axios
			.delete(
				`${process.env.REACT_APP_API_URL}pages/team-1/sections/${teamMemberSlug}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(_ => onStart() && toast.success("تم الحذف بنجاح"))
			.catch(_ => toast.error("حدث خطا!"));
	};

	const handleShowModal = (type, teamMemberSlug) => {
		setModaleType(type);
		setShowModal(true);
		if (teamMemberSlug) {
			axios
				.get(
					`${process.env.REACT_APP_API_URL}pages/team-1/sections/${teamMemberSlug}`,
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (res) {
					setSelectedTeamMember(res?.data?.data?.section);
				})
				.catch(function (err) {});
		}
	};

	const handleCloseModal = () => {
		setShowModal(!showModal);
		reset();
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<div className="d-flex align-items-center justify-content-between px-4 my-5">
							<h3 className="main-title ps-3"> جميع الاعضاء </h3>
							<button
								type="button"
								onClick={() => {
									handleShowModal("add");
								}}
								className="bg-green-500 text-white px-3 py-2 rounded btn btn-success"
							>
								+ اضافة عضو جديد
							</button>
						</div>

						<div className="datatable">
							<DataTableExtensions columns={columns} data={teamData}>
								<DataTable
									noHeader
									defaultSortField="id"
									defaultSortAsc={false}
									pagination
									highlightOnHover
									direction="rtl"
									striped
								/>
							</DataTableExtensions>
						</div>
					</div>
				</div>
			</div>
			{showModal && (
				<TeamModal
					showModal={handleShowModal}
					handleCloseModal={handleCloseModal}
					modalType={modalType}
					selectedTeamMember={selectedTeamMember}
					loading={loading}
					setLoading={setLoading}
					onStart={onStart}
				/>
			)}
		</section>
	);
};

export default TeamMembersIndex;
